/* ============================================================
   IZVOR — Premium Cart controller
   Uses the Shopify Cart AJAX API + Section Rendering API so the
   page always reflects REAL server-side prices, line discounts
   and automatic discounts (no faked totals at checkout).
   ============================================================ */
(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-izvor-cart]';

  // Section ids (as defined in templates/cart.json) to re-render on change.
  function refreshTargets(root) {
    var raw = root.getAttribute('data-izv-refresh') || '';
    return raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
  }

  function getRoot(el) { return el.closest(ROOT_SELECTOR) || document.querySelector(ROOT_SELECTOR); }

  function setBusy(root, busy) {
    if (!root) return;
    root.classList.toggle('izv-cart-busy', !!busy);
  }

  // Replace the inner markup of each refreshed section from a sections payload.
  function applySections(sections) {
    Object.keys(sections || {}).forEach(function (id) {
      var html = sections[id];
      if (html == null) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      // The Section Rendering API returns the full <div id="shopify-section-..."> wrapper.
      var incoming = doc.querySelector('#shopify-section-' + id) || doc.body.firstElementChild;
      var current = document.getElementById('shopify-section-' + id);
      if (incoming && current) {
        current.innerHTML = incoming.innerHTML;
      }
    });
  }

  function notifyTheme(cart) {
    // Best-effort: keep the theme's header count / cart drawer in sync.
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:refresh', { bubbles: true })
      );
      if (window.PubSub && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        window.PubSub.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'izvor-cart', cartData: cart });
      }
    } catch (e) { /* no-op */ }
    document.querySelectorAll('[data-izv-count]').forEach(function (n) {
      if (cart && typeof cart.item_count === 'number') n.textContent = cart.item_count;
    });
  }

  function cartRequest(url, body, root) {
    var targets = refreshTargets(root);
    if (targets.length) body.sections = targets.join(',');
    body.sections_url = window.location.pathname;
    setBusy(root, true);
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.sections) applySections(data.sections);
        // Fetch a clean cart object for the header/count.
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) { notifyTheme(cart); return data; });
      })
      .catch(function (err) { console.error('[izvor-cart]', err); })
      .finally(function () {
        // root may have been replaced by re-render; clear busy on the live one.
        var live = document.querySelector(ROOT_SELECTOR);
        setBusy(live, false);
      });
  }

  function changeLine(root, line, quantity, props) {
    var body = { line: line, quantity: quantity };
    if (props) body.properties = props;
    return cartRequest('/cart/change.js', body, root);
  }

  function addItems(root, items) {
    return cartRequest('/cart/add.js', { items: items }, root);
  }

  // ---- event delegation ----
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-izv-action]');
    if (!t) return;
    var root = getRoot(t);
    if (!root) return;
    var action = t.getAttribute('data-izv-action');

    if (action === 'inc' || action === 'dec') {
      e.preventDefault();
      var line = parseInt(t.getAttribute('data-line'), 10);
      var qty = parseInt(t.getAttribute('data-qty'), 10);
      var next = action === 'inc' ? qty + 1 : qty - 1;
      changeLine(root, line, Math.max(0, next));
    }

    else if (action === 'remove') {
      e.preventDefault();
      changeLine(root, parseInt(t.getAttribute('data-line'), 10), 0);
    }

    else if (action === 'add') {
      e.preventDefault();
      var item = { id: parseInt(t.getAttribute('data-variant'), 10), quantity: 1 };
      var sp = t.getAttribute('data-selling-plan');
      if (sp) item.selling_plan = parseInt(sp, 10);
      addItems(root, [item]);
    }

    else if (action === 'toggle-sub') {
      e.preventDefault();
      var ln = parseInt(t.getAttribute('data-line'), 10);
      var isOn = t.classList.contains('is-on');
      var sellingPlan = t.getAttribute('data-selling-plan');
      // If a real selling plan is configured, switch the line to/from it.
      if (sellingPlan) {
        var body = { line: ln, quantity: parseInt(t.getAttribute('data-qty'), 10) || 1,
          selling_plan: isOn ? '' : parseInt(sellingPlan, 10) };
        body.sections = refreshTargets(root).join(',');
        body.sections_url = window.location.pathname;
        setBusy(root, true);
        fetch('/cart/change.js', { method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (d) { if (d && d.sections) applySections(d.sections);
            return fetch('/cart.js').then(function (r) { return r.json(); }).then(notifyTheme); })
          .finally(function () { setBusy(document.querySelector(ROOT_SELECTOR), false); });
      } else {
        // No subscription app: toggle a line property as an interest flag (no price change).
        changeLine(root, ln, parseInt(t.getAttribute('data-qty'), 10) || 1,
          isOn ? { 'Абонамент': '' } : { 'Абонамент': 'Да' });
      }
    }

    else if (action === 'bundle-select') {
      e.preventDefault();
      var key = t.getAttribute('data-bundle');
      root.querySelectorAll('[data-izv-action="bundle-select"]').forEach(function (b) {
        b.classList.toggle('is-sel', b === t);
      });
      var addBtn = root.querySelector('[data-izv-action="bundle-add"]');
      if (addBtn) addBtn.setAttribute('data-bundle', key);
    }

    else if (action === 'bundle-add') {
      e.preventDefault();
      var n = t.getAttribute('data-bundle') === '2' ? 2 : 3;
      var variants = (t.getAttribute('data-variants') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var picked = variants.slice(0, n).map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      if (picked.length) addItems(root, picked);
    }
  });

  // qty typed directly (if an input is present)
  document.addEventListener('change', function (e) {
    var inp = e.target.closest('input[data-izv-action="set-qty"]');
    if (!inp) return;
    var root = getRoot(inp);
    var line = parseInt(inp.getAttribute('data-line'), 10);
    var q = Math.max(0, parseInt(inp.value, 10) || 0);
    changeLine(root, line, q);
  });

  // Discount code apply (uses Shopify's /discount route → real automatic/code discount)
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-izv-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = (input && input.value || '').trim();
    if (code) window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/cart';
  });
})();
